import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'

// basic acl
import { ACLComponent } from 'src/app/components/cleanui/system/ACL/acl.component'

// antd components module
import { AntdModule } from 'src/app/antd.module'
import { GlobalDirectivesModule } from './directives/global-directives.module';

const MODULES = [
	AntdModule,
	CommonModule,
	RouterModule,
	TranslateModule,
	GlobalDirectivesModule,
]

@NgModule({
	imports: [...MODULES],
	declarations: [ACLComponent],
	exports: [...MODULES],
})
export class SharedModule {}
